import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  initEaState,
  changeEaState,
  saveEaJsonData,
  getEaPlanDetail,
  changePlanStatus,
  searchUndecidedContract,
} from '@store/actions/eaAction';
import { showModal } from '@store/actions/commonAction';

import EaPartSubLnb from '@components/ea/EaPartSubLnb';
import EaPlanInfoMain from '@container/ea/EaPlanInfoMain';
import EaAuthMain from '@container/ea/EaAuthMain';
import CustomerInfoCheck from '@container/ea/CustomerInfoCheck';
import SignAgree from '@container/ea/SignAgree';
import EaPdfViewerMain from '@container/ea/EaPdfViewerMain';
import EaCompleteMain from './EaCompleteMain';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';

import jumpToPagePlugin from '@container/pdfviewer/jumpToPagePlugin';
import { getToday } from '@common/utils/date';
import { checkEaStatusReady } from '@common/utils';

const EaPartSubMain = props => {
  const {
    setEaPartSubPopup,
    planEstablishNo,
    applicationNo,
    isSelectRow,
    isConstractChange, // 청약변경 진행 여부
    republishType, // 재발행 타입
  } = props;

  const { fillEaOriginalData } = $hooks.useEa();
  const [title1Status, setTitle1Status] = useState(false);
  const [title2Status, setTitle2Status] = useState(false);
  const [title3Status, setTitle3Status] = useState(false);
  const [isAuthPopup, setIsAuthPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pdfPageNum, setPdfPageNum] = useState('');

  const [isUpdatePage, setIsUpdatePage] = useState('');
  // const [isTimerPopup, setIsTimerPopup] = useState(false);
  const [notCompletePageNum, setNotCompletePageNum] = useState(0);
  const [notCompleteMsg, setNotCompleteMsg] = useState('');
  const [isNotCompletePopup, setIsNotCompletePopup] = useState(false);
  const [notCompletePdfPageNum, setNotCompletePdfPageNum] = useState(0);
  const [isCompletePopup, setIsCompletePopup] = useState(false);
  const [isUpdatePop, setIsUpdatePop] = useState(false);
  const [isMoblieCert, setIsMobileCert] = useState(false);

  const jumpToPagePluginInstance = jumpToPagePlugin();
  const { jumpToPage } = jumpToPagePluginInstance;

  const {
    planMainInfo,
    completePage,
    bookmark,
    authTime,
    completePdfPage,
    pdfPath,
    authCustomerInfo,
  } = useSelector(state => state.eaReducer);
  const dispatch = useDispatch();

  // 전자청약 닫기 버튼
  const onClickEaCloseBtn = () => {
    dispatch(
      showModal({
        visible: true,
        type: 'confirm',
        msg: '전자 청약을 종료하시겠어요? 입력하신 정보는 자동 저장됩니다.',
        onOk: {
          handle: () => handleCloseConfirmBtn(),
        },
      }),
    );
  };

  // 전자청약 닫기 버튼 팝업 확인 버튼
  const handleCloseConfirmBtn = () => {
    setEaPartSubPopup(false);

    dispatch(
      changeEaState({
        type: 'authTime',
        data: getToday('yyyyMMdd'),
      }),
    );
    dispatch(
      changePlanStatus({
        applicationNo: applicationNo,
        status: 'Q',
        republishType,
      }),
    );
    dispatch(
      saveEaJsonData({
        applicationNo: applicationNo,
        docType: isConstractChange ? '5' : '1',
        callback: saveJsonCallBack,
        isClose: true, // 닫기 버튼 클릭 여부
      }),
    );
  };

  // 저장완료 후 전자청약닫기
  const saveJsonCallBack = type => {
    if (type) {
      setEaPartSubPopup(false);
      // dispatch(initEaState());
    }
  };

  // 페이지 변경
  const handlePageChange = value => {
    if (pdfPath === '') {
      if (value === 0 || value === 1) {
        setCurrentPage(value);
      } else {
        if (!completePage.includes(1)) {
          setIsAuthPopup(true);
        } else {
          if (value === 4) {
            let checkPage = [1, 2, 3];
            if (checkPage.length > completePage.length) {
              const notCompletePage = checkPage.filter(
                data => !completePage.includes(data),
              );
              const minNotCompletePage = Math.min(...notCompletePage);
              if (minNotCompletePage !== 3) {
                setNotCompletePageNum(minNotCompletePage);
                setNotCompleteMsg(
                  `전자문서 서명 동의가 작성되지 않아 청약 완료가 불가합니다. 청약문서 작성 완료해 주세요.`,
                );
                setIsNotCompletePopup(true);
              } else {
                const filterBookmark = bookmark.filter(
                  data => data.code !== '',
                );
                if (filterBookmark.length > completePdfPage.length) {
                  const notCompletePdfPage = filterBookmark.filter(
                    data => !completePdfPage.includes(data.code),
                  )[0];
                  const minNotCompletePdfPageNum =
                    notCompletePdfPage.pn.split(',')[0];
                  setNotCompletePdfPageNum(Number(minNotCompletePdfPageNum));
                  setNotCompleteMsg(
                    `${notCompletePdfPage.title} 문서가 작성되지 않아 청약 완료가 불가합니다. 청약문서 작성 완료해 주세요.`,
                  );
                  setIsNotCompletePopup(true);
                  setNotCompletePageNum(minNotCompletePage);
                } else {
                  setIsCompletePopup(true);
                }
              }
            } else {
              setIsCompletePopup(true);
            }
            // setIsCompletePopup(true);
          } else {
            setCurrentPage(value);
          }
        }
      }
    } else {
      if (isUpdatePage !== '' || value === 4) {
        setCurrentPage(value);
      } else {
        setIsUpdatePop(true);
        setIsUpdatePage(value);
      }
    }
  };

  // 전자청약서 목차 클릭
  const handleEaBookmarkClick = value => {
    if (pdfPath === '') {
      if (!completePage.includes(1)) {
        setIsAuthPopup(true);
      } else {
        setCurrentPage(4);
        const splitPage = value.split(',');
        if (currentPage === 4) {
          jumpToPage(Number(splitPage[0]) - 1);
          setPdfPageNum(splitPage[0]);
        }
        setPdfPageNum(splitPage[0]);
      }
    } else {
      if (isUpdatePage !== '') {
        setCurrentPage(4);
        const splitPage = value.split(',');
        if (currentPage === 4) {
          jumpToPage(Number(splitPage[0]) - 1);
          setPdfPageNum(splitPage[0]);
        }
        setPdfPageNum(splitPage[0]);
      } else {
        setIsUpdatePop(true);
        setIsUpdatePage(value);
      }
    }
  };

  // 다음 클릭
  const handleNextClick = () => {
    setCurrentPage(prev => prev + 1);

    const checkPages = [...Array(4).keys()].map(v => v + 1);

    // 현재 페이지의 이후 문서 중 완료되지 않은 페이지 추출
    const notCompletePage = checkPages.filter(
      data => currentPage < data && !completePage.includes(data),
    );

    if (notCompletePage.length === 0) {
      setCurrentPage(prev => prev + 1);
      return;
    }

    setCurrentPage(notCompletePage[0]);
  };

  // 이전 클릭
  const handlePrevClick = () => {
    setCurrentPage(currentPage - 1);
  };

  // 미완료된 페이지 이동
  const pageJumpNotCompletePage = () => {
    setIsNotCompletePopup(false);
    if (notCompletePageNum !== 3) {
      setCurrentPage(notCompletePageNum);
    } else {
      handleEaBookmarkClick(String(notCompletePdfPageNum));
    }
  };

  // 청약문서 만들고나서 수정 팝업 확인 버튼 클릭
  const handleUpdateConfirmBtnClick = () => {
    setIsUpdatePop(false);
    if (typeof isUpdatePage !== 'string') {
      setCurrentPage(isUpdatePage);
    } else {
      setCurrentPage(3);
      const splitPage = isUpdatePage.split(',');
      jumpToPage(Number(splitPage[0]) - 1);
      setPdfPageNum(splitPage[0]);
    }
  };

  useEffect(() => {
    // plan 상세조회
    dispatch(
      getEaPlanDetail({
        planEstablishNo: planEstablishNo,
        isConstractChange: isConstractChange,
        isPracticeMode: false,
        isPartSub: true,
        callback: (_, planMainInfo) => fillEaOriginalData(planMainInfo),
      }),
    );

    /////////////////////////
    // 청약서류 보완 최초 작성시 && 청약변경신청서가 아닌 경우 에만 미결 데이터 조회
    const isEaStatusReady = checkEaStatusReady(isSelectRow.progressStep);
    if (isEaStatusReady && !isConstractChange) {
      dispatch(searchUndecidedContract({ policyNo: isSelectRow.policyNo }));
    }

    // 화면 진입시 작성 중 상태 변경
    dispatch(
      changePlanStatus({
        applicationNo: applicationNo,
        status: 'Q',
        republishType,
      }),
    );
  }, [planEstablishNo, applicationNo]);

  useEffect(() => {
    if (currentPage > 0 && currentPage < 4) {
      setTitle1Status(true);
      setTitle2Status(false);
      setTitle3Status(false);
      setPdfPageNum('0');
    }
    if (currentPage === 4) {
      setTitle1Status(false);
      setTitle2Status(true);
      setTitle3Status(false);
      const lastPdfPage = bookmark.filter(
        data =>
          completePdfPage.length === 0 ||
          data.code === completePdfPage[completePdfPage.length - 1],
      )[0].pn;
      setPdfPageNum(lastPdfPage.split(',')[0]);
    }
    if (currentPage > 4) {
      setTitle1Status(false);
      setTitle2Status(false);
      setTitle3Status(true);
      setPdfPageNum('0');
    }
  }, [currentPage]);

  // 조회 후 완료 페이지 및 본인인증 시간 체크
  useEffect(() => {
    if (completePage.length > 0) {
      if (!completePage.find(item => item === 1) && authTime !== '') {
        setCurrentPage(1);
      }
    } else {
      setCurrentPage(0);
    }
  }, [authTime]);

  useEffect(() => {
    return () => {
      dispatch(initEaState());
    };
  }, []);

  return (
    <>
      <div className="container">
        <EaPartSubLnb
          title1Status={title1Status}
          setTitle1Status={setTitle1Status}
          title2Status={title2Status}
          setTitle2Status={setTitle2Status}
          planMainInfo={planMainInfo}
          onClickEaCloseBtn={onClickEaCloseBtn}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          completePage={completePage}
          bookmark={bookmark}
          title3Status={title3Status}
          setTitle3Status={setTitle3Status}
          onClickEaBookmark={handleEaBookmarkClick}
          pdfPageNum={pdfPageNum}
          completePdfPage={completePdfPage}
          isConstractChange={isConstractChange}
        />
        <div className="content">
          {currentPage === 0 && (
            <EaPlanInfoMain
              planMainInfo={planMainInfo}
              onClickNext={handleNextClick}
              republishYn={true}
              isPartSub={true}
              isConstractChange={isConstractChange}
            />
          )}
          {currentPage === 1 && (
            <EaAuthMain
              authCustomerInfo={authCustomerInfo}
              onClickPrev={handlePrevClick}
              onClickNext={handleNextClick}
              handlePageChange={handlePageChange}
              setIsAuthPopup={setIsAuthPopup}
              completePage={completePage}
              applicationNo={applicationNo}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setPdfPageNum={setPdfPageNum}
              isPartSub={true}
              isConstractChange={isConstractChange}
            />
          )}
          {currentPage === 2 && (
            <SignAgree
              applicationNo={applicationNo}
              onClickPrev={handlePrevClick}
              onClickNext={handleNextClick}
              currentPage={currentPage}
            />
          )}
          {currentPage === 3 && (
            <CustomerInfoCheck
              applicationNo={applicationNo}
              onClickPrev={handlePrevClick}
              onClickNext={handleNextClick}
              insuredPrspCustNo={planMainInfo.insuredPrspCustNo}
              ownerPrspCustNo={planMainInfo.ownerPrspCustNo}
              ownerCustKind={'P'}
              optionalRiderList={planMainInfo.optionalRiderList}
              isMoblieCert={isMoblieCert}
              setCurrentPage={setCurrentPage}
            />
          )}
          {currentPage === 4 && (
            <EaPdfViewerMain
              currentPag={currentPage}
              pdfPageNum={pdfPageNum}
              setPdfPageNum={setPdfPageNum}
              jumpToPagePluginInstance={jumpToPagePluginInstance}
              custNo={planMainInfo.ownerPrspInfo.custNo}
              applicationNo={applicationNo}
              jumpToPage={jumpToPage}
              setCurrentPage={setCurrentPage}
              isPartSub={true}
              isConstractChange={isConstractChange}
              republishYn={true}
            />
          )}
          {currentPage === 5 && (
            <EaCompleteMain
              applicationNo={applicationNo}
              complete={completePage.includes(5)}
              completePage={completePage}
              setEaMainPopup={setEaPartSubPopup}
              setIsUpdatePage={setIsUpdatePage}
              setCurrentPage={setCurrentPage}
              setIsMobileCert={setIsMobileCert}
              isPartSub={true}
              isConstractChange={isConstractChange}
              republishType={republishType}
              republishYn={true}
            />
          )}
        </div>
      </div>
      <SatModal
        visible={isAuthPopup}
        setVisible={() => {
          setIsAuthPopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">
                  {
                    '본인 인증 및 서명 등록이 되지 않아 다음 단계로 이동할 수 없습니다.'
                  }
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => setIsAuthPopup(false)}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isNotCompletePopup}
        setVisible={() => {
          setIsNotCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">{notCompleteMsg}</p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => pageJumpNotCompletePage()}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isCompletePopup}
        setVisible={() => {
          setIsCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">
                  {
                    '알림톡(SMS)을 통하여 전달한 모바일 약관을 수령(다운로드)하고 작성완료 보완문서를 확인한 경우 보완이 완료됩니다.'
                  }
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => {
                    setIsCompletePopup(false);
                    setCurrentPage(5);
                  }}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isUpdatePop}
        setVisible={() => {
          setIsUpdatePop(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`다른 단계로 이동시 작성내용이 수정됩니다. 작성된 내용을 수정하시겠어요?.`}
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'취소'}
                  onClick={() => {
                    setIsUpdatePop(false);
                    setIsUpdatePage('');
                  }}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'확인'}
                  onClick={() => {
                    handleUpdateConfirmBtnClick();
                  }}
                />
              </div>
            </>
          );
        }}
      />
    </>
  );
};

export default EaPartSubMain;
